const infoBlock = document.querySelector(".article-content__info");
const sidebar = document.querySelector(".fixed__sidebar");

if (infoBlock && sidebar) {
    const infoTop = infoBlock.getBoundingClientRect().top + window.scrollY;
    const sidebarTop = sidebar.getBoundingClientRect().top + window.scrollY;

    const offset = sidebarTop - infoTop;

    infoBlock.style.top = `-${offset}px`;
}